import * as React from "react";

import { Button } from "@/domain/ui/Button";
import { env } from "@/env";

type DiscordButtonProps = React.ComponentProps<typeof Button>;

export function DiscordButton({ onClick, ...props }: DiscordButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    window.open(env.VITE_DISCORD_URL, "_blank", "noopener,noreferrer");
    onClick?.(e);
  };

  return <Button onClick={handleClick} {...props} />;
}
